import React, { useState, useEffect } from 'react';
import { Row, Col, CardBody, Input, Button, FormGroup, Label, InputGroup, InputGroupAddon } from 'reactstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import APIClient from '../../../helpers/APIClient';
import Loader from '../../../components/Loader';
import { connect } from 'react-redux';
import { baseUrl } from '../../../constants/environment';
import { checkRole } from '../../../helpers/Roles';
import moment from 'moment';
import styled from 'styled-components';
import IconCalendar from '../../../assets/images/icon/ic_calendar-black.svg';
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import PhoneImageIcon from '../../../assets/images/icon-phone.png';
import { cloneDeep, isEmpty } from 'lodash';


const AddressAdd = (props: any) => {
    const { closeModal, action, onlyView, customer_id, address, setAddress, updateRealTime, isDefault } = props
    const [users, setUser] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any>();
    const [province, setProvince] = useState<any>([]);
    const [district, setDistrict] = useState<any>([]);
    const [ward, setWard] = useState<any>([]);
    
    
    const type = action?.type

    useEffect(() => {
        fetchProvince()
    }, []);

    useEffect(() => {
        if(action?.data?.id)loadData()
    }, [action?.data?.id]);

    useEffect(() => {
        
        if(props?.isDefault){
            setData({
                ...action?.data,
                status: 1
            })
        }else{
            setData(action?.data) 
        }
        if(action?.data?.provinces_code?.code) fetchDistrict(action?.data?.provinces_code?.code);
        if(action?.data?.district_code?.code) fetchWard(action?.data?.district_code?.code);
    }, [action?.data]);

    const loadData = async () => {
        const url = `${baseUrl}/customer/address/${action?.data?.id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            setData(resData)
        }
    }

    const fetchProvince = async () => {
        const url = `${baseUrl}/address/provinces`;
        const params = {
            page:1,
            limit: 100,
        }
        let response: any = await APIClient.GET(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response?.data !== undefined) {
            let ListArr:any = [];
            response.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: Number(e?.code),
                    label: e?.name
                })
            })
            setProvince(ListArr)
        }
    }

    const fetchDistrict = async (province_code:any) => {
        const url = `${baseUrl}/address/districts`;
        const params = {
            page:1,
            limit: 500,
            province_code: province_code
        }
        let response: any = await APIClient.GET(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response?.data !== undefined) {
            let ListArr:any = [];
            response.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: Number(e?.code),
                    label: e?.name
                })
            })
            setDistrict(ListArr)
        }
    }

    const fetchWard = async (district_code:any) => {
        const url = `${baseUrl}/address/wards`;
        const params = {
            page:1,
            limit: 500,
            district_code: district_code
        }
        let response: any = await APIClient.GET(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response?.data !== undefined) {
            let ListArr:any = [];
            response.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: Number(e?.code),
                    label: e?.name
                })
            })
            setWard(ListArr)
        }
    }

    const handleChangeInput = (event?: any) => {
        let { value, name } = event.target
        if (value === " ") return;
        if (name === "phone") {
            value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "")
        }
        setData({
            ...data,
            [name]: value
        })
    }

    const handleSetDefault = () => {
        const status = data?.status === 1 ? 0 : 1
        if( (action?.type === 'edit' || action?.type === 'editAddress') && status === 0){
            //ko cho bỏ địa chỉ mặc định, chỉ khio chọn địa chỉ khác làm địa chỉ mặc định mới tự đổi trajgn thái cảu nó
            return
        }
        setData({...data, status: status})
    }

    const validationFrom = () => {
        if (isEmpty(data.name)) {
            toast.warning('Tên khách hàng không được để trống!');
            return false
        }
        if (isEmpty(data.phone)) {
            toast.warning('Số điện thoại không được để trống!');
            return false
        }
        if (!data.provinces_code) {
            toast.warning('Tỉnh/ Thành phố không được để trống!');
            return false
        }
        if (!data.district_code) {
            toast.warning('Quận/ Huyện không được để trống!');
            return false
        }
        if (!data.wards_code) {
            toast.warning('Phường/ Xã không được để trống!');
            return false
        }
        if (isEmpty(data.street)) {
            toast.warning('Địa chỉ chi tiết không được để trống!');
            return false
        }
        return true
    }
    
    const handleSave = async() => {
        if (!validationFrom()) return;
        if(action?.type === 'add' || action?.type === 'addAddress'){
            let newAddress:any = cloneDeep(address)
            if(data?.status === 1){
                newAddress = newAddress?.reduce((prev:any, item:any)=>{
                    prev = [...prev, {
                        ...item,
                        status: 0
                    }]
                    return prev
                },[])
            }
            newAddress.push({
                ...data,
                status: data?.status ? 1: 0
            })
            setAddress(newAddress)
            closeModal()
            toast.success('Thêm địa chỉ nhận hàng thành công')
        }else if(action?.type === 'edit' || action?.type === 'editAddress'){
            if(updateRealTime && data?.id){
                const url = `${baseUrl}/customer/address/${data?.id}`;
                setLoading(true)
                let response: any = await APIClient.PUT(url, {
                    ...data,
                    district_code: data?.district_code?.code,
                    provinces_code: data?.provinces_code?.code,
                    wards_code: data?.wards_code?.code,
                });
                setLoading(false)
            }
            let newAddress:any = cloneDeep(address)
            if(data?.status === 1){
                newAddress = newAddress?.reduce((prev:any, item:any)=>{
                    item.status = 0
                    prev = [...prev, item]
                    return prev
                },[])
            }
            newAddress[action?.index] = {
                ...data,
                status: data?.status ? 1: 0
            }
            setAddress([
                ...newAddress
            ])
            closeModal()
            toast.success('Sửa địa chỉ nhận hàng thành công')
        }
    }

    if(!checkRole(props?.user?.roles, ['editCustomer', 'addCustomer'], props?.user?.role)){
        return (
            <CardBody className='p-0' style={{width:460}}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-action-title">
                        Thông báo
                    </h5>
                    <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
                </div>
                <div className="modal-body pt-2 pb-2">
                    <Col md={12}>
                        <FormGroup row className="label-only">
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>
                                Bạn không có quyền thực hiện thao tác này
                            </p>
                        </FormGroup>
                    </Col>
                </div>
                <div className="modal-footer">
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland" color="success" type="button"
                    > Hủy bỏ</Button>
                </div>
                {loading && <Loader />}
            </CardBody>
    
        )
    }
    
    return (
        <CardBody className='p-0' style={{width: 750}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                {
                    (action?.type === 'add' || action?.type === 'addAddress' ) ? "Thêm địa chỉ nhận hàng" :
                    (action?.type === 'edit' || action?.type === 'editAddress') ? "Chỉnh sửa địa chỉ nhận hàng" :
                    action?.type === 'view' ? "Chi tiết địa chỉ nhận hàng"
                    : "Thông báo"
                }
                </h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body p-2 pt-4">
                <PageContent className={onlyView ? 'only-view' : ''}>
                    <Col md={12}>
                        <FormGroup className="label-only">
                            <Row>
                                <Col md={6} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span>Tên khách hàng</Label>
                                        <Input type="text" value={data?.name} onChange={(e: any) => handleChangeInput(e)} name="name" placeholder="Nhập tên khách hàng" />
                                    </FormGroup>
                                </Col>
                                <Col md={6} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span> Số điện thoại</Label>
                                        {type === 'view' ? <ValueText>{data?.phone}</ValueText>:
                                        <InputGroup>
                                            <Input type="text" value={data?.phone} onChange={(e: any) => handleChangeInput(e)} name="phone" placeholder="Nhập số điện thoại" />
                                            {
                                                type!='view' &&
                                                <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                                                    <img src={PhoneImageIcon} width={18} height={18} alt=""/>
                                                </InputGroupAddon>
                                            }
                                        </InputGroup>
                                        }
                                        
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span>Tỉnh/ Thành phố</Label>
                                        <Select
                                            placeholder="Chọn Tỉnh/ Thành phố"
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            isDisabled={onlyView}
                                            onChange={(val: any) => {
                                                setData({ ...data, provinces_code: val, district_code: null, wards_code: null })
                                                fetchDistrict(val?.code);
                                            }}
                                            value={province?.filter(
                                                (option: any) => data?.provinces_code?.code == option.value
                                            )}
                                            options={province}
                                        ></Select>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span>Quận/ Huyện</Label>
                                        <Select
                                            placeholder="Chọn Quận/ Huyện"
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            isDisabled={onlyView}
                                            onChange={(val: any) => {
                                                setData({ ...data, district_code: val, wards_code: null })
                                                fetchWard(val?.code);
                                            }}
                                            value={district?.filter(
                                                (option: any) => data?.district_code?.code == option.value
                                            )}
                                            options={district}
                                        ></Select>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span>Phường/ Xã</Label>
                                        <Select
                                            placeholder="Chọn Phường/ Xã"
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            isDisabled={onlyView}
                                            onChange={(val: any) => {
                                                setData({ ...data, wards_code: val})
                                            }}
                                            value={ward?.filter(
                                                (option: any) => data?.wards_code?.code == option.value
                                            )}
                                            options={ward}
                                        ></Select>
                                    </FormGroup>
                                </Col>
                                <Col md={6} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span>Địa chỉ chi tiết</Label>
                                        <Input type="text" value={data?.street} onChange={(e: any) => handleChangeInput(e)} name="street" placeholder="Nhập địa chỉ chi tiết" />
                                    </FormGroup>
                                </Col>
                                <Col md={6} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Ghi chú</Label>
                                        <Input type="text" value={data?.note} onChange={(e: any) => handleChangeInput(e)} name="note" placeholder="Nhập ghi chú" />
                                    </FormGroup>
                                </Col>
                                <Col md={12} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <div className={data?.status === 1 ? "nutri-radio active" : "nutri-radio"} onClick={() => ( type=='view' || isDefault ) ? {} :handleSetDefault() }>
                                            <div className="icon"></div>
                                            <div className="label">Địa chỉ nhận hàng mặc định</div>
                                        </div>
                                    </FormGroup>
                                </Col>
                               
                            </Row>
                        </FormGroup>
                    </Col>
                </PageContent>
            </div>
            {action?.type !== 'view' &&
            <div className="modal-footer">
                <Button onClick={()=>{closeModal()}} className="ml-2 success-bland" color="success" type="button" >Hủy bỏ</Button>
                <Button onClick={()=>{handleSave()}} className="ml-2" color="success" type="button" >{action?.type === 'editAddress' ? "Cập nhật":"Lưu"}</Button>
            </div>}
            {loading && <Loader />}
        </CardBody>
    )
}

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`
const ValueText = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
`

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

export default connect(mapState)(AddressAdd)